import React from 'react'

const Backend = () => {
    return (
        <div className="skills__content">
          <h3 className="skills__title">Backend Developer</h3>
          <div className="skills__box">
            <div className="skills__group">
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
    
                <div>
                  <h3 className="skills__name">Node Js</h3>
                  <span className="skills__level">Intermediate</span>
                </div>
              </div>
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
    
                <div>
                  <h3 className="skills__name">C++</h3>
                  <span className="skills__level">Advanced</span>
                </div>
              </div>
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
    
                <div>
                  <h3 className="skills__name">AWS</h3>
                  <span className="skills__level">Intermediate</span>
                </div>
              </div>
              </div>
              <div className='skills__group'>
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
    
                <div>
                  <h3 className="skills__name">SQL</h3>
                  <span className="skills__level">Intermediate</span>
                </div>
              </div>
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
    
                <div>
                  <h3 className="skills__name">MG DB</h3>
                  <span className="skills__level">Intermediate</span>
                </div>
              </div>
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
    
                <div>
                  <h3 className="skills__name">Docker</h3>
                  <span className="skills__level">Intermediate</span>
                </div>
                </div>
            </div>
          </div>
        </div>
      );
    };

export default Backend